var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('vue-element-loading',{attrs:{"active":_vm.loading > 0,"is-full-screen":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }